/**
 * Event dispatched when a comment containing an agent @mention is saved.
 * Listened to by useAgentMentionSidebarListener to open the CwR sidebar.
 */
export const AGENT_MENTION_COMMENT_SAVED_EVENT = 'confluence:agent-mention-comment-saved';

/** Timeout for the agent ID resolution fetch (ms). */
export const AGENT_RESOLVE_TIMEOUT_MS = 5_000;

/**
 * Content types whose comment surfaces do **not** support the V1 agent
 * invocation / post-back flow. Agents must not appear in the mention picker
 * for these surfaces so users cannot start an invocation that cannot complete.
 *
 * Supported/unsupported surface matrix (V1):
 * ┌─────────────┬───────────────────────┐
 * │ Content type │ Agent mentions in     │
 * │              │ comment picker        │
 * ├─────────────┼───────────────────────┤
 * │ page        │ ✅ Supported          │
 * │ blogpost    │ ✅ Supported          │
 * │ whiteboard  │ ❌ Not supported (V1) │
 * │ database    │ ❌ Not supported (V1) │
 * └─────────────┴───────────────────────┘
 */
export const AGENT_MENTION_UNSUPPORTED_CONTENT_TYPES: ReadonlySet<string> = new Set([
	'whiteboard',
	'database',
]);

/**
 * Returns `true` when the given content type supports agent mentions in its
 * comment picker for the current (V1) release.
 */
export function isAgentMentionSupportedForContentType(
	contentType: string | undefined | null,
): boolean {
	if (!contentType) {
		return false;
	}
	return !AGENT_MENTION_UNSUPPORTED_CONTENT_TYPES.has(contentType);
}

// Reuse the page-session polling window when a comment loses live status updates.
export const AGENT_SESSION_SUBSCRIPTION_FAILED_EVENT =
	'confluence:agent-session-subscription-failed';
